module.exports = __webpack_public_path__ + "img/hb_chai.ae0a77ca.png";